import { useMutation } from "react-query";
import { Put } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { Cart } from "../../types/api/Cart";
import { useQueryClient } from "react-query";

export interface AddLineItemBody {
  product_id: string;
  quantity: number;
}

export default (cartId: string, sellerOrgId: string, buyerOrgId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Cart, null, AddLineItemBody>(
    async (body: AddLineItemBody) =>
      Put(
        `/api/cart/${cartId}/line_item`,
        await getAccessTokenSilently(),
        body
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          `current_cart_${sellerOrgId}_${buyerOrgId}`,
        ]);
      },
    }
  );
};
